import { createUseStyles } from 'react-jss'
import Slider from 'react-slick'
import style from './style'

const useStyles = createUseStyles(style)

const CarouselHTML = ({
  arrows,
  centerMode,
  dots,
  variableWidth,
  children,
  slidesToShow,
  infinite,
}) => {
  const classes = useStyles()

  const renderSimpleGallery = () => {
    const slickSettings = {
      dots,
      arrows,
      speed: 600,
      cssEase: 'cubic-bezier(0, 0, 0.17, 0.97)',
      touchThreshold: 20,
      infinite,
      slidesToShow,
      centerMode,
      variableWidth,
    }

    return (
      <div className={classes.root}>
        <div className={classes.carousel}>
          <Slider
            dots={slickSettings.dots}
            arrows={slickSettings.arrows}
            speed={slickSettings.speed}
            cssEase={slickSettings.cssEase}
            touchThreshold={slickSettings.touchThreshold}
            infinite={slickSettings.infinite}
            slidesToShow={slickSettings.slidesToShow}
            centerMode={slickSettings.centerMode}
            variableWidth={slickSettings.variableWidth}
            afterChange={slickSettings.afterChange}
            nextArrow={slickSettings.nextArrow}
            prevArrow={slickSettings.prevArrow}
            className={`${classes.slick} Carousel__slick`}
          >
            {children}
          </Slider>
        </div>
      </div>
    )
  }

  return renderSimpleGallery()
}

CarouselHTML.defaultProps = {
  centerMode: false,
  dots: false,
  parallax: false,
  variableWidth: false,
  infinite: false,
  slidesToShow: 1,
}

export default CarouselHTML
